<template>
  <div>
    <iq-card>
      <template #headerTitle>
        <h5 class="text-primary mb-0">
          <strong>Multiple Maintenance Process</strong>
        </h5>
      </template>

      <template #body>
        <form @submit.prevent="handleSubmit">
          <!-- Search & Filter -->
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <b-form class="d-flex mb-3">
                <b-form-input
                  id="fleet_name"
                  style="width: 200px"
                  type="text"
                  placeholder="Search fleet name..."
                  v-model="jobList.params.search"
                ></b-form-input>
              </b-form>
              <b-button
                variant="outline-primary"
                class="d-flex align-items-center ml-2"
                style="height: max-content"
                @click="modalFilter = true"
              >
                <i class="fas fa-sliders"></i>
                <p class="text-truncate m-0"> Filter Data</p>
              </b-button>
            </div>
            <div>
              <b-button
                variant="danger"
                @click="handleBulkDelete"
                :disabled="!hasCheckedItems"
              >
                <i class="fa fa-trash-alt mr-2"></i>Bulk Delete
              </b-button>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="sticky-col sticky-col-1">
                    <b-form-checkbox
                      class="d-flex justify-content-center"
                      :checked="isCheckedAll"
                      @change="toggleSelectAll"
                    />
                  </th>
                  <th class="text-nowrap sticky-col sticky-col-2"
                    >Fleet Name</th
                  >
                  <th
                    class="text-nowrap sticky-col sticky-col-3"
                    style="min-width: 240px"
                  >
                    Equipment Name
                  </th>
                  <th class="text-nowrap" style="min-width: 200px"
                    >Maintenance Date</th
                  >
                  <th class="text-nowrap" style="min-width: 200px"
                    >Running Hours</th
                  >
                  <th class="text-nowrap" style="min-width: 200px">Cost</th>
                  <th class="text-nowrap" style="min-width: 200px">
                    Maintenance File
                  </th>
                  <th class="text-nowrap" style="min-width: 400px"
                    >Maintenance Note</th
                  >
                </tr>
              </thead>
              <tbody>
                <tr v-for="(job, index) in paginatedForms" :key="index">
                  <td class="sticky-col sticky-col-1">
                    <b-form-checkbox
                      type="checkbox"
                      :value="job.unique_id"
                      v-model="checkedJobs"
                      class="d-flex justify-content-center"
                    />
                  </td>
                  <td class="sticky-col sticky-col-2">
                    <b-badge variant="success">{{ job.vehicle_name }}</b-badge>
                  </td>
                  <td class="sticky-col sticky-col-3">
                    {{ job.job_libraries?.maintenance_master.equipment_name }}
                  </td>

                  <!-- Maintenance Date -->
                  <td style="min-width: 180px">
                    <date-picker
                      v-model="job.job_libraries.maintenance_date"
                      value-type="YYYY-MM-DD"
                    ></date-picker>
                  </td>

                  <td style="min-width: 180px">
                    <b-input-group v-if="method == 'COUNTER'" append="Hours">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="
                          job.job_libraries.last_maintenance_interval_hour
                        "
                        placeholder="Enter hours"
                      ></b-form-input>
                    </b-input-group>
                  </td>

                  <td style="min-width: 180px">
                    <InputCurrency
                      type="number"
                      min="0"
                      v-model="job.job_libraries.cost"
                      placeholder="Enter hours"
                    ></InputCurrency>
                  </td>

                  <!-- Maintenance File -->
                  <td style="min-width: 400px">
                    <b-form-file
                      v-model="job.job_libraries.attachments"
                      placeholder="Choose file..."
                      browse-text="Browse"
                      multiple
                      @input="(files) => onFilesSelected(job, files)"
                    ></b-form-file>
                    <div
                      class="mt-2"
                      v-if="
                        normalizeFiles(job.job_libraries.attachments).length
                      "
                    >
                      <b-badge
                        v-for="(f, fi) in normalizeFiles(
                          job.job_libraries.attachments
                        )"
                        :key="`att-${index}-${fi}`"
                        variant="info"
                        class="mr-2"
                      >
                        {{ f.name || 'attachment' }}
                        <i
                          class="fa fa-times ml-1 cursor-pointer"
                          title="Remove"
                          @click.stop="removeAttachment(job, fi)"
                        ></i>
                      </b-badge>
                    </div>
                  </td>
                  <!-- Maintenance Note -->
                  <td style="min-width: 400px">
                    <b-form-input
                      v-model="job.job_libraries.maintenance_note"
                      placeholder="Enter note"
                    ></b-form-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div
            class="my-4 d-flex align-items-center w-100 justify-content-between"
          >
            <p>
              Total Rows:
              <strong class="text-black fw-bold">{{ totalRows }}</strong>
            </p>
            <div class="d-flex align-items-center">
              <b-pagination
                class="mb-0 mr-3"
                v-model="jobList.params.page"
                :total-rows="totalRows"
                :per-page="jobList.params.limit"
                first-number
                align="center"
                @change="onPageChange"
              ></b-pagination>
              <b-form-select
                plain
                v-model="jobList.params.limit"
                :options="limitOptions"
                style="width: 140px"
                @change="onLimitChange"
              ></b-form-select>
            </div>
          </div>

          <!-- Buttons -->
          <div class="d-flex">
            <b-button
              variant="outline-primary"
              class="w-50 mr-2"
              @click="$emit('close')"
            >
              Cancel
            </b-button>
            <b-button variant="primary" class="w-50" @click="handleSubmit">
              Save
            </b-button>
          </div>
        </form>
      </template>
    </iq-card>
  </div>
</template>

<script>
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import { pmsActions } from '@/src/Utils/helper'

export default {
  name: 'FormMaintenanceProcess',
  components: {
    InputCurrency,
  },
  props: {
    multipleSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalFilter: false,
      checkedJobs: [],
      jobList: {
        params: {
          page: 1,
          limit: 5,
          search: '',
        },
      },
      limitOptions: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 25, text: '25' },
      ],
      jobs: [
        // {
        //   unique_id: 2,
        //   vehicle_name: 'Fleet Bravo',
        //   job_libraries: {
        //     maintenance_master: { equipment_name: 'Main Engine' },
        //     interval_hour: 500,
        //     last_maintenance_date: '2025-09-20',
        //     last_maintenance_interval_hour: 400,
        //     maintenance_note: '',
        //     attachments: null,
        //   },
        // },
      ],
    }
  },
  computed: {
    hasCheckedItems() {
      return this.checkedJobs.length > 0
    },
    isCheckedAll() {
      return this.checkedJobs.length === this.jobs.length
    },
    totalRows() {
      return this.jobs.length
    },
    paginatedForms() {
      const start = (this.jobList.params.page - 1) * this.jobList.params.limit
      const end = start + this.jobList.params.limit
      return this.jobs.slice(start, end)
    },
  },
  methods: {
    ...pmsActions,
    normalizeFiles(src) {
      if (!src) return []
      if (src instanceof FileList) return Array.from(src)
      if (Array.isArray(src)) return src
      if (src instanceof File) return [src]
      return []
    },
    onFilesSelected(job, files) {
      // Coerce any incoming FileList/File/Array into a plain array of File
      const arr =
        files instanceof FileList
          ? Array.from(files)
          : Array.isArray(files)
          ? files
          : files instanceof File
          ? [files]
          : []
      if (!job.job_libraries) job.job_libraries = {}
      job.job_libraries.attachments = arr
    },
    removeAttachment(job, index) {
      const arr = this.normalizeFiles(job?.job_libraries?.attachments)
      if (!arr.length) return
      arr.splice(index, 1)
      job.job_libraries.attachments = arr.length ? arr : null
    },
    async handleUploadFiles(files) {
      const formData = new FormData()
      for (const file of files) {
        formData.append('files', file)
      }
      const res = await this.uploadFilePmsMultiple(formData)
      return res.data?.data?.files || []
    },

    async handleSubmit() {
      // Process ALL rows currently visible in the form (checkboxes are only for delete)
      const visibleJobs = this.paginatedForms
      if (!visibleJobs.length) {
        this.$swal(
          'Tidak ada data',
          'Tidak ada data pada halaman ini untuk diproses.',
          'warning'
        )
        return
      }

      try {
        const payload = []
        for (const job of visibleJobs) {
          const jl = job.job_libraries || {}
          const date = jl.maintenance_date || null
          const hoursRaw = jl.last_maintenance_interval_hour
          const hasHours =
            hoursRaw !== undefined && hoursRaw !== null && `${hoursRaw}` !== ''
          const hours = hasHours ? Number(hoursRaw) : undefined

          // attachments mapping (multiple files -> upload first then map response array)
          const filesSrc = jl.attachments
          const filesArr = filesSrc
            ? filesSrc instanceof FileList
              ? Array.from(filesSrc)
              : Array.isArray(filesSrc)
              ? filesSrc
              : filesSrc instanceof File
              ? [filesSrc]
              : []
            : []
          const uploadedFiles = filesArr.length
            ? await this.handleUploadFiles(filesArr)
            : []

          const attachments = uploadedFiles

          const process = {
            maintenance_date: date,
            ...(hasHours ? { maintenance_running_hours: hours } : {}),
            cost: jl.cost || 0,
            notes: jl.maintenance_note || '',
            finish_notes: jl.finish_notes || '',
            maintenance_attachments: attachments,
            cost: jl.cost,
          }

          payload.push({
            action: 'process',
            maintenance_id: job.unique_id,
            process,
          })
        }
        const res = await this.actionMaintenanceMultiple(payload)
        if (res.status == 'success') {
          this.$swal(
            'Success',
            res.data.message || 'Success Multiple Process.',
            'success'
          )
          this.$emit('refetch')
          this.$emit('close')
        } else {
          this.$swal('Error', res.data.message || 'Error occurred', 'error')
        }
      } catch (e) {
        this.$swal('Error', 'Failed to send data.', 'error')
      }
    },
    handleBulkDelete() {
      this.jobs = this.jobs.filter(
        (job) => !this.checkedJobs.includes(job.unique_id)
      )
      this.checkedJobs = []
    },
    toggleSelectAll(e) {
      if (e) this.checkedJobs = this.jobs.map((j) => j.unique_id)
      else this.checkedJobs = []
    },
    onPageChange(page) {
      this.jobList.params.page = page
    },
    onLimitChange() {
      this.jobList.params.page = 1
    },
  },
  mounted() {
    // Initialize checkedJobs to empty
    this.checkedJobs = []
    if (this.multipleSelected.length) {
      this.jobs = this.multipleSelected.map((j) => ({
        unique_id: j.id,
        vehicle_name: j?.vehicle_name,
        method: j?.job_library?.method,
        job_libraries: {
          cost: 0,
          maintenance_master: { equipment_name: j?.equipment_name },
          interval_hour: '',
          maintenance_date: '',
          last_maintenance_interval_hour: '',
          maintenance_note: '',
          attachments: null,
        },
      }))
    }
  },
}
</script>

<style scoped>
.table td,
.table th {
  vertical-align: middle;
}
.badge {
  font-size: 0.8rem;
  padding: 0.4em 0.6em;
}

/* Sticky columns styles */
.sticky-col {
  position: sticky;
  background-color: #f8f9fa;
  z-index: 10;
}
.sticky-col-1 {
  left: 0;
  min-width: 60px;
}
.sticky-col-2 {
  left: 60px;
  min-width: 120px;
}
.sticky-col-3 {
  left: 180px;
  min-width: 240px;
}
tbody .sticky-col {
  background-color: #ffffff;
}
.sticky-col-3::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 2px;
  background-color: #dee2e6;
}
.table-hover tbody tr:hover .sticky-col {
  background-color: #f5f5f5;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
